module.exports = __webpack_public_path__ + "assets/img/Mission-Background.9ab7baca.png";